"use strict";

angular.module('app.shared.countryListService', [])
  .service('app.shared.countryListService', [
    function () {
      return {
        countries: [
          {
            abbr: "US",
            name: "United States"
          },
          {
            abbr: "CA",
            name: "Canada"
          },
          {
            abbr: "AL",
            name: "Albania"
          },
          {
            abbr: "AR",
            name: "Argentina"
          },
          {
            abbr: "AU",
            name: "Australia"
          },
          {
            abbr: "AT",
            name: "Austria"
          },
          {
            abbr: "BR",
            name: "Brazil"
          },
          {
            abbr: "BS",
            name: "Bahamas"
          },
          {
            abbr: "BY",
            name: "Belarus"
          },
          {
            abbr: "BE",
            name: "Belgium"
          },
          {
            abbr: "KY",
            name: "Cayman Islands"
          },
          {
            abbr: "CZ",
            name: "Czech Republic"
          },
          {
            abbr: "DK",
            name: "Denmark"
          },
          {
            abbr: "EE",
            name: "Estonia"
          },
          {
            abbr: "FK",
            name: "Falkland Islands"
          },
          {
            abbr: "FI",
            name: "Finland"
          },
          {
            abbr: "FR",
            name: "France"
          },
          {
            abbr: "DE",
            name: "Germany"
          },
          {
            abbr: "GE",
            name: "Georgia"
          },
          {
            abbr: "GR",
            name: "Greece"
          },
          {
            abbr: "HK",
            name: "Hong Kong"
          },
          {
            abbr: "HU",
            name: "Hungary"
          },
          {
            abbr: "IN",
            name: "India"
          },
          {
            abbr: "IS",
            name: "Iceland"
          },
          {
            abbr: "IE",
            name: "Ireland"
          },
          {
            abbr: "IL",
            name: "Israel"
          },
          {
            abbr: "IT",
            name: "Italy"
          },
          {
            abbr: "JP",
            name: "Japan"
          },
          {
            abbr: "KZ",
            name: "Kazakhstan"
          },
          {
            abbr: "LV",
            name: "Latvia"
          },
          {
            abbr: "LT",
            name: "Lithuania"
          },
          {
            abbr: "LU",
            name: "Luxembourg"
          },
          {
            abbr: "MX",
            name: "Mexico"
          },
          {
            abbr: "MM",
            name: "Myanmar"
          },
          {
            abbr: "NL",
            name: "Netherlands"
          },
          {
            abbr: "NZ",
            name: "New Zealand"
          },
          {
            abbr: "NO",
            name: "Norway"
          },
          {
            abbr: "PL",
            name: "Poland"
          },
          {
            abbr: "RU",
            name: "Russian Federation"
          },
          {
            abbr: "RO",
            name: "Romania"
          },
          {
            abbr: "SG",
            name: "Singapore"
          },
          {
            abbr: "SK",
            name: "Slovakia"
          },
          {
            abbr: "SI",
            name: "Slovenia"
          },
          {
            abbr: "ZA",
            name: "South Africa"
          },
          {
            abbr: "ES",
            name: "Spain"
          },
          {
            abbr: "SE",
            name: "Sweden"
          },
          {
            abbr: "CH",
            name: "Switzerland"
          },
          {
            abbr: "UA",
            name: "Ukraine"
          },
          {
            abbr: "GB",
            name: "United Kingdom"
          }
        ]
      }
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/countryListService.js